<!--
 * @Author: your name
 * @Date: 2021-10-25 14:55:48
 * @LastEditTime: 2021-11-15 17:30:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\Xunzhangshu_Website\xzswebsite\src\components\home.vue
-->
<template>
<!-- dev环境 -->
  <div class="bigBox">
    <el-container>
      <el-header>
        <div class="title">
          <div>
            <img src="../assets/img/xzs_logo.png" />
            <span style="color:#fff;">勋章树</span>
          </div>
          <div>
            <div>
              <span>首页</span>
            </div>
            <!-- <div>
            <span @click="toEnterprise">企业服务</span>
            </div>-->
            <div>
              <span @click="toAbout">关于我们</span>
            </div>
            <!-- <div>
            <span @click="toJoin">加入我们</span>
            </div>-->
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="content">
          <div class="c_left">
            <img src="../assets/img/whitePhone.png" alt />
          </div>
          <div class="c_right">
            <div style="font-size:75px;margin-top:170px;">勋章树</div>
            <div style="font-size:48px;">助力企业与个人的成长</div>
            <!-- <div style="margin-top:50px;">
            <div>
              <img src="../assets/img/iOS.png" alt="">
            </div>
            <div style="margin-left:40px;">
              <img src="../assets/img/Android.png" alt="">
            </div>
            </div>-->
            <div class="code" style="margin-top:50px;">
              <div class="ios" v-if="!iosShow" @mouseleave="ioscode">
                <img src="../assets/img/ioswhite.png" />
                <img src="../assets/img/ioscode.png" />
              </div>
              <div class="ios_" v-if="iosShow" @mousemove="ioscode_">
                <img src="../assets/img/ioswhite.png" />
              </div>
              <div class="android" v-if="!androidShow" @mouseleave="androidcode">
                <img src="../assets/img/androidwhite.png" />
                <img src="../assets/img/androidcode.png" />
              </div>
              <div class="android_" v-if="androidShow" @mousemove="androidcode_">
                <img src="../assets/img/androidwhite.png" />
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div class="bottom">
          <div style="color:#fff;">
            <span>服务协议</span>
            <span>隐私协议</span>
            <span>关于我们</span>
            <span>加入我们</span>
          </div>
                    
          <div >
            经营许可 :
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color:#f14016;"
            >沪ICP备2021032438号</a> | Copyright 上海士鸢信息科技有限公司 | 地址 : 上海市闵行区燎申国际大厦5楼F、G室
          </div>
          <div>联系电话：021-64051039 | 邮箱:ad@seasfly.com</div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "",
      iosShow: true,
      androidShow: true
    };
  },
  methods: {
    toEnterprise() {
      this.$router.push("enterprise");
    },
    toAbout() {
      this.$router.push("about");
    },
    toJoin() {
      this.$router.push("join");
    },
    ioscode() {
      this.iosShow = true;
    },
    ioscode_() {
      this.iosShow = false;
    },
    androidcode() {
      this.androidShow = true;
    },
    androidcode_() {
      this.androidShow = false;
    }
  },
  mounted() {}
};
</script>

<style scoped lang='less'>
a {
  text-decoration: none;
}

// body {
//   width: 100%;
//   height: 100vh;
// }
// .boxShadow{
//   position: absolute;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   background: #000;
//   opacity: 0.5;
//   z-index: -1;
// }
.el-container {
  height: 100vh;
  // background-image: url("../assets/img/backgroundImage.png");
  background-image: url("../assets/img/backgroundImage.jpeg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-color: rgba(0, 0, 0, 0.5);
  .title {
    max-width: 1280px;
    // height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    font-size: 18px;
    z-index: 999;
    margin-top: 20px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
    > div {
      display: flex;
      height: 30px;
      align-items: center;
    }
    > div:nth-child(2) {
      > div {
        margin-right: 48px;
        color: #c4c4c4;
        cursor: pointer;
      }
      > div:first-child {
        color: #fff;
        border-bottom: 2px solid #fff;
      }
      > div:last-child {
        margin-right: 0;
      }
    }
  }
  .content {
    max-width: 920px;
    display: flex;
    margin: 0 auto;
    margin-top: 100px;
    z-index: 999;
    .c_left {
      > img {
        width: 293px;
        height: 592px;
      }
    }
    .c_right {
      width: 100%;
      text-align: left;
      color: #fff;
      font-family: PingFangSC;
      font-weight: 500;
      margin-left: 50px;
      > div {
        margin-bottom: 16px;
      }
      > div:last-child {
        display: flex;
        img {
          width: 168px;
          height: 50px;
        }
      }
      .code {
        display: flex;
        .ios {
          // width: 292px;
          // margin-left: 8%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-radius: 30px;
          padding-bottom: 10px;
          > img:nth-child(1) {
            width: 168px;
            height: 50px;
            // border-radius: 25px;
          }
          > img:nth-of-type(2) {
            width: 140px;
            height: 140px;
            // margin-top: 12px;
          }
        }
        .ios_ {
          > img:nth-child(1) {
            width: 168px;
            height: 50px;
            // border-radius: 25px;
          }
          // width: 250px;
          // margin-left: 8%;
        }
        .android {
          // width: 250px;
          margin-left: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-radius: 30px;
          padding-bottom: 10px;
          > img:nth-child(1) {
            width: 168px;
            height: 50px;
            // border-radius: 25px;
          }
          > img:nth-of-type(2) {
            width: 140px;
            height: 140px;
            // margin-top: 12px;
          }
        }
        .android_ {
          > img:nth-child(1) {
            width: 168px;
            height: 50px;
            // border-radius: 25px;
          }
          // width: 292px;
          margin-left: 40px;
        }
      }
    }
  }
  .bottom {
    // position: absolute;
    // bottom: 0;
    // left: 50%;
    // transform: translateX(-50%);
    width: 950px;
    height: 100%;
    margin: 0 auto;
    font-size: 14px;
    font-family: PingFangSC;
    color: #999;
    z-index: 999;
    text-align: center;
    > div:first-child {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      > span {
        cursor: pointer;
      }
    }
  }
  /deep/.el-footer{
    height: fit-content !important;
    padding-bottom: 20px;
  }
}
</style>
